import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { faMinusSquare, faPlane } from '@fortawesome/free-solid-svg-icons';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
// eslint-disable-next-line import-whitelist -- this component will be moved to core once all button is done in new toolbar epic
import { SettingsService } from '../../../core/h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { KeyboardShortcutService } from '../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { EventTrackingValueWithSource } from '../../../cross-team-shared/misc-utils';
import { settingsStoreToken } from '../../../cross-team-shared/state/setting-state';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';

@Component({
  selector: 'h3-view-settings-3d',
  templateUrl: './view-settings-3d.component.html',
  styleUrls: ['./view-settings-3d.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettings3DComponent
  extends DirectiveSuperclass
  implements OnInit
{
  useOrthographicCamera$!: Observable<boolean>;
  hideGround$!: Observable<boolean>;
  showRoute$!: Observable<boolean>;

  hasRouteFlag!: boolean;

  faPlane = faPlane;
  faMinusSquare = faMinusSquare;

  toggleEnhancedPointCloudTooltip!: string;
  toggleOrthographicCameraTooltip!: string;
  resetCameraTooltip!: string;

  private settingsStore = inject(settingsStoreToken);
  private keyboardShortcutService = inject(KeyboardShortcutService);
  private settingsService = inject(SettingsService);
  private store = inject(PointCloudContentStore);

  ngOnInit() {
    this.useOrthographicCamera$ = this.settingsStore('useOrthographicCamera').$;
    this.hideGround$ = this.store('render')('hideGround').$;
    this.showRoute$ = this.settingsStore('showRoute').$;

    this.toggleEnhancedPointCloudTooltip =
      'Toggle Enhanced Point Cloud' +
      this.keyboardShortcutService.getTooltipSuffix('toggleEnhancedPointCloud');

    this.toggleOrthographicCameraTooltip =
      'Toggle Orthographic Camera' +
      this.keyboardShortcutService.getTooltipSuffix('toggleOrthographicCamera');

    this.resetCameraTooltip =
      'Reset Camera' +
      this.keyboardShortcutService.getTooltipSuffix('resetSensorView');
  }

  toggleShowRoute() {
    this.settingsService.toggleShowRoute();
  }

  toggleOrthographicCamera() {
    this.settingsService.toggleOrthographicCamera({ source: 'button' });
  }

  toggleHideGround() {
    this.settingsService.toggleHideGround();
  }

  resetCamera(eventTrackingValueWithSource: EventTrackingValueWithSource) {
    this.settingsService.resetSensorView(eventTrackingValueWithSource);
  }
}
